/*
 * @Author: 李旭
 * @Date: 2021-12-03 16:05:42
 * @LastEditTime: 2021-12-03 16:28:58
 * @LastEditors: 李旭
 * @Description: localstorage的封装
 * @FilePath: \ems-web-ant5.0\src\utils\storage.js
 *
 */
import store from 'store';
import moment from 'moment';
export function get(name) {
  const getValue = store.get(name);
  const timestapNow = moment().valueOf();
  if (getValue && getValue.hasOwnProperty('now')) {
    if (timestapNow - getValue.now >= getValue.timestap) {
      return null;
    } else {
      return getValue.data;
    }
  } else {
    return getValue;
  }
}
export function set(name, data, timestap) {
  const timestapNow = moment().valueOf();
  if (arguments.length == 2) {
    store.set(name, { data });
  } else if (arguments.length == 3) {
    store.set(name, { data, now: timestapNow, timestap: timestap });
  } else {
    throw '必须填写正确的键值对';
  }
}

export function clear() {
  if (arguments.length == 0) {
    store.clearAll();
  } else {
    [...arguments].map((item) => {
      store.remove(item);
    });
  }
}
